export default "__VITE_ASSET__ntHoWcN3__"